import { extendTheme } from '@blockanalitica/ui';
import { colors } from './colors';
import space from './space';
import sizes from './sizes';
import { card } from './components/card';
import { kpiHeader } from './components/kpiHeader';
import { kpiFooter } from './components/kpiFooter';
import { navigationItem } from './components/navigationItem';
import { linkButton } from './components/linkButton';
import { listHeader } from './components/listHeader';
import { listItem } from './components/listItem';
import { cardHeader } from './components/cardHeader';
import { heatmap } from './components/heatmap';
import { heatmapColumnLabel } from './components/heatmapColumnLabel';
import { heatmapRowLabel } from './components/heatmapRowLabel';
import { heatmapCell } from './components/heatmapCell';
import { chartKpi } from './components/ChartKpis/chartKpi';
import { chartKpiPoint } from './components/ChartKpis/chartKpiPoint';
import { chartKpiLabel } from './components/ChartKpis/chartKpiLabel';
import { chartKpiValue } from './components/ChartKpis/chartKpiValue';
import { chartKpiSubValue } from './components/ChartKpis/chartKpiSubValue';
import { chart } from './components/chart';
import { table } from './components/table';
import { headerCell } from './components/headerCell';
import { tableCell } from './components/tableCell';
import { tableRow } from './components/tableRow';
import { paginationCurrentNavigation } from './components/paginationCurrentNavigation';
import { paginationLegend } from './components/paginationLegend';
import { paginationContainer } from './components/paginationContainer';
import { select } from './components/select';
import { kpiCardValue } from './components/KpiCard/kpiCardValue';
import { kpiCardBodyTrend } from './components/KpiCard/kpiCardBodyTrend';
import { kpiCardFooter } from './components/KpiCard/kpiCardFooter';
import { kpiCardHeader } from './components/KpiCard/kpiCardHeader';
import { dropdown } from './components/dropdown';
import { dropdownOption } from './components/dropdownOption';
import { dropdownHeader } from './components/dropdownHeader';
import { dropdownList } from './components/dropdownList';
import { heading } from './components/heading';
import { modal } from './components/modal';
import { modalHeader } from './components/modalHeader';
import { modalBackground } from './components/modalBackground';
import { walletAddressHeader } from './components/walletAddressHeader';
import { displaySwitch } from './components/displaySwitch';
import { displaySwitchOption } from './components/displaySwitchOption';
import { currencyValue } from './components/currencyValue';
import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';

export const theme: Theme = extendTheme({
  rootFontSize: '12px',
  breakpoints: [850],
  fontBreakpoints: [600, 768, 1024, 1280],
  colors,
  sizes,
  space,
  charts: {
    minFontSize: 9,
    maxFontSize: 12
  },
  components: [
    card,
    cardHeader,
    kpiHeader,
    kpiFooter,
    navigationItem,
    linkButton,
    listHeader,
    listItem,
    heatmap,
    heatmapColumnLabel,
    heatmapRowLabel,
    heatmapCell,
    chartKpi,
    chartKpiPoint,
    chartKpiLabel,
    chartKpiValue,
    chartKpiSubValue,
    chart,
    table,
    tableCell,
    tableRow,
    headerCell,
    paginationCurrentNavigation,
    paginationLegend,
    paginationContainer,
    select,
    kpiCardValue,
    kpiCardBodyTrend,
    kpiCardFooter,
    kpiCardHeader,
    dropdown,
    dropdownOption,
    dropdownHeader,
    dropdownList,
    heading,
    modal,
    modalHeader,
    modalBackground,
    walletAddressHeader,
    displaySwitch,
    displaySwitchOption,
    currencyValue
  ]
});
